import { useState, useEffect } from 'react';
import api from '../services/api';
import { Software } from '../types';

/**
 * Hook to fetch software list from the backend.
 * Maps to GET /softaware/software (which also lives at /updates/software).
 */
export function useSoftware() {
  const [software, setSoftware] = useState<Software[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const res = await api.get('/softaware/software');
        const data = res.data?.software || res.data?.data || [];
        if (!cancelled) setSoftware(Array.isArray(data) ? data : []);
      } catch (err: any) {
        if (!cancelled) setError(err.message || 'Failed to load software');
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };
    load();
    return () => { cancelled = true; };
  }, []);

  return { software, isLoading, error };
}
